import React from 'react';
import { BaseEdge, EdgeProps, getBezierPath } from '@xyflow/react';

const BPMNEdge: React.FC<EdgeProps> = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  style = {},
  markerEnd,
  data
}) => {
  const [edgePath] = getBezierPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  });

  const isAlternative = data?.type === 'alternative' || style.strokeDasharray;

  return (
    <>
      <BaseEdge
        id={id}
        path={edgePath}
        markerEnd={markerEnd}
        style={{
          ...style,
          stroke: isAlternative ? '#0dcaf0' : (style.stroke || '#6c757d'),
          strokeWidth: isAlternative ? 3 : (style.strokeWidth || 2),
          strokeDasharray: isAlternative ? '5,5' : '0',
        }}
      />
    </>
  );
};

export default BPMNEdge;


